import { fireOnce, trackStructuredEvent } from 'src/analytics';
import { getCategory } from 'src/interviews/analytics';
import type { MiniInterviewType } from 'src/packages/polaris/types';

export const trackSupplierConfirmationOfferingViewed = ({
  interviewToken,
  interviewType,
  chargeAmount,
}: {
  interviewToken: string;
  interviewType: MiniInterviewType;
  chargeAmount: number;
}) => {
  const event = {
    category: getCategory(interviewType),
    action: 'get-dx-confirmed-cta-viewed',
    label: interviewToken,
    property: `${chargeAmount}`,
  };
  const key = `${event.category}:${event.action}:${event.label}`;
  fireOnce(() => trackStructuredEvent(event), `${key}`);
};

export const trackSupplierConfirmationOfferingClicked = ({
  interviewToken,
  interviewType,
  chargeAmount,
}: {
  interviewToken: string;
  interviewType: MiniInterviewType;
  chargeAmount: number;
}) => {
  const event = {
    category: getCategory(interviewType),
    action: 'get-dx-confirmed-cta-clicked',
    label: interviewToken,
    property: `${chargeAmount}`,
  };
  const key = `${event.category}:${event.action}:${event.label}`;
  fireOnce(() => trackStructuredEvent(event), `${key}`);
};

export const trackQuestionSubmit = ({
  interviewToken,
  interviewType,
  questionNumber,
  chargeAmount,
}: {
  interviewToken: string;
  interviewType: MiniInterviewType;
  questionNumber: number;
  chargeAmount: number;
}) => {
  trackStructuredEvent({
    category: getCategory(interviewType),
    action: 'get-dx-confirmed-question-submit',
    label: interviewToken,
    value: questionNumber,
    property: `${chargeAmount}`,
  });
};

export const trackSubmissionOfPayment = ({
  interviewToken,
  interviewType,
  chargeAmount,
}: {
  interviewToken: string;
  interviewType: MiniInterviewType;
  chargeAmount: number;
}) => {
  trackStructuredEvent({
    category: getCategory(interviewType),
    action: 'get-dx-confirmed-payment-submitted',
    label: interviewToken,
    property: `${chargeAmount}`,
  });
};

export const trackPaymentFieldClick = ({
  interviewToken,
  interviewType,
  element,
  chargeAmount,
}: {
  interviewToken: string;
  interviewType: MiniInterviewType;
  element: string;
  chargeAmount: number;
}) => {
  trackStructuredEvent({
    category: getCategory(interviewType),
    action: 'get-dx-confirmed-payment-field-clicked',
    label: interviewToken,
    property: element,
    value: chargeAmount,
  });
};
